import { Component, input, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NeoMenu, NeoMenuModule } from '@neogov/pattern-library/neo-menu';

@Component({
  selector: 'cm-menu',
  standalone: true,
  imports: [CommonModule, NeoMenuModule],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.less',
  exportAs: 'cmMenu',
})
export class MenuComponent {
  public readonly xPosition = input<'before' | 'after'>('after');
  public readonly yPosition = input<'above' | 'below'>('below');
  public readonly autId = input<string>('cm-menu');

  // Expose the internal neo-menu so it can be used with neoMenuTriggerFor
  public readonly neoMenu = viewChild.required<NeoMenu>('neoMenu');
}
